import { IconBuilder } from "/app/src/components/icons/IconBuilder";
import { Spinner } from "@heroui/react";

/**
 * Renders an icon based on the provided status.
 *
 * @param {Object} props - The component props.
 * @param {number} props.status - The status to determine which icon to display.
 * @returns {JSX.Element} The rendered icon component.
 */
export default function StatusIcon({ status }: { status: number }) {
  if (status === 1) {
    return (
      <IconBuilder
        icon="Checkmark"
        size={24}
        color="#188845"
        className="flex items-center pl-[15px]"
      />
    );
  } else if (status === 2) {
    return <Spinner size="sm" />;
  } else {
    return (
      <IconBuilder
        icon="Close"
        size={24}
        color="#E00000"
        className="flex items-center pl-[15px]"
      />
    );
  }
}
